import { BadgeCheck, MailX, ShieldCheck } from "lucide-react";

const STATUS = {
  active: ["Activa", "bg-green-100 text-green-700"],
  deleted: ["Eliminada", "bg-zinc-200 text-zinc-700"],
  messaging_blocked: ["Mensagens bloqueadas", "bg-orange-100 text-orange-800"],
};

export function AdminUsersList({ users }) {
  const other = Object.values(users.reduce((acc, u) => {
    const k = (u.city_other || "").trim().toLowerCase();
    if (!k || u.city || u.status === "deleted") return acc;
    acc[k] = acc[k] || { city: u.city_other.trim(), count: 0 };
    acc[k].count += 1;
    return acc;
  }, {})).sort((a, b) => b.count - a.count);
  if (!users.length) return <p data-testid="admin-users-empty" className="text-sm text-zinc-500 italic text-center py-8">Sem utilizadores.</p>;
  return (
    <div data-testid="admin-users-list" className="space-y-2 mb-8">
      <p className="text-xs text-zinc-500">{users.length} utilizador(es) · apenas visualização</p>
      {other.length > 0 && (
        <div data-testid="admin-other-cities" className="bg-amber-50 border border-amber-200 rounded-2xl p-3 text-xs">
          <div className="font-semibold text-amber-900 mb-1">Cidades fora da lista ({other.reduce((a, o) => a + o.count, 0)})</div>
          <div className="flex flex-wrap gap-1.5">{other.map(o => <span key={o.city} className="px-2 py-0.5 rounded-full bg-white border border-amber-200 text-amber-900" data-testid={`admin-other-city-${o.city}`}>{o.city} · {o.count}</span>)}</div>
          <p className="text-[10px] text-amber-800 mt-1">Indicadas por membros no registo — útil para decidir as próximas comunidades locais.</p>
        </div>
      )}
      {users.map(u => {
        const [label, cls] = STATUS[u.status] || STATUS.active;
        return (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="bg-white rounded-2xl border border-zinc-200 p-3">
            <div className="flex items-center gap-1 font-semibold text-sm truncate">
              {u.role === "admin" && <ShieldCheck size={13} className="text-[#c8102e]" />}
              <span data-testid={`admin-user-name-${u.id}`}>{u.name || "(sem nome)"}</span>
            </div>
            <div data-testid={`admin-user-email-${u.id}`} className="text-[11px] text-zinc-600 truncate">{u.email}</div>
            <div className="text-[10px] text-zinc-400 mt-0.5">
              Registo: {u.created_at ? new Date(u.created_at).toLocaleString("pt-PT") : "—"}{u.city ? ` · ${u.city}` : ""}{!u.city && u.city_other ? ` · Outra: ${u.city_other}` : ""}
            </div>
            <div className="flex flex-wrap gap-1 mt-1.5">
              <span data-testid={`admin-user-status-${u.id}`} className={`text-[10px] px-2 py-0.5 rounded-full font-semibold ${cls}`}>{label}</span>
              <span data-testid={`admin-user-verified-${u.id}`} className={`inline-flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full font-semibold ${u.email_verified ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-800"}`}>
                {u.email_verified ? <BadgeCheck size={10} /> : <MailX size={10} />}{u.email_verified ? "Email verificado" : "Email não verificado"}
              </span>
              <span data-testid={`admin-user-role-${u.id}`} className="text-[10px] px-2 py-0.5 rounded-full font-semibold bg-zinc-100 text-zinc-700">{u.role === "admin" ? "Admin" : "Utilizador"}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
